import { NotificationAlertOverride } from ".";
import { NotificationHandleType } from "../../Notifications";
import {
  createRequirementAction,
  createRequirementChildren,
  createRequirementTitle,
  GenericRequirementNotificationContext
} from "./helper";

export const RequirementsAwaitingReviewPayee: NotificationAlertOverride<
  GenericRequirementNotificationContext
> = (notification, history) => {
  return {
    theme: "info",
    icon: "time",
    title: createRequirementTitle(
      notification,
      NotificationHandleType.RequirementsAwaitingReviewPayee
    ),
    children: createRequirementChildren(
      notification,
      NotificationHandleType.RequirementsAwaitingReviewPayee
    ),
    action: createRequirementAction(notification, history)
  };
};
